module.exports = __webpack_public_path__ + "static/media/user-img.f871375f.png";